import './LangflowFeedback.scss';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import CopyButton from 'components/CopyButton/CopyButton';
import { Message } from '../../../Hooks/useLangflowChat';
import { useLangflowChatContext } from '../../../contexts/LangflowChat.context';
import { useGetTraceId, useFeedbackMutation } from 'queries/chatbot/queries';
import { useState, useCallback } from 'react';

type FeedbackStatus = 'positive' | 'negative' | null;

export const LangflowFeedback = ({ lastBotMessage }: { lastBotMessage: Message }) => {
  const { selectedSessionId } = useLangflowChatContext();
  const [feedbackStatus, setFeedbackStatus] = useState<FeedbackStatus>(null);

  const { data: traceIdResponse } = useGetTraceId(selectedSessionId);
  const traceId = traceIdResponse?.data?.[0]?.id ?? '';
  const { mutate: sendFeedback } = useFeedbackMutation(traceId);

  const handleFeedbackClick = useCallback(
    (isPositive: boolean) => {
      setFeedbackStatus(isPositive ? 'positive' : 'negative');
      sendFeedback(isPositive);
    },
    [sendFeedback],
  );

  return (
    <div className="langflow-feedback-container">
      <ThumbUpAltOutlinedIcon
        onClick={() => handleFeedbackClick(true)}
        className={feedbackStatus === 'positive' ? 'langflow-feedback-clicked' : ''}
      />
      <ThumbDownAltOutlinedIcon
        onClick={() => handleFeedbackClick(false)}
        className={feedbackStatus === 'negative' ? 'langflow-feedback-clicked' : ''}
      />
      <CopyButton text={lastBotMessage.content} showCopyText={false} />
    </div>
  );
};
